var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SaucerProvider } from '@saucerjs/core';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
export var SaucerEditorProvider = React.memo(function (props) {
    return (React.createElement(SaucerProvider, __assign({}, props),
        React.createElement(DndProvider, { backend: HTML5Backend }, props.children)));
});
SaucerEditorProvider.displayName = 'SaucerEditorProvider';
